// extracted by mini-css-extract-plugin
var _1 = "accordion__Rap6B";
var _2 = "actions__QYZUh";
var _3 = "body__p4oKE";
var _4 = "header__lHOUz";
var _5 = "header-wrapper__enIZi";
var _6 = "headline___ercj";
var _7 = "headline-icon__aJiLI";
var _8 = "open__NNH_J";
var _9 = "sub-headline__GMtuU";
export { _1 as "accordion", _2 as "actions", _3 as "body", _4 as "header", _5 as "header-wrapper", _6 as "headline", _7 as "headline-icon", _8 as "open", _9 as "sub-headline" }
